import React from 'react'
import classNames from 'classnames'
import Check from 'wix-ui-icons-common/Check'
import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {useTranslation} from '@wix/yoshi-flow-editor'
import {getPlanBenefitText, planVisible} from '../../../../selectors/paid-plans'
import s from '../membership-offers.scss'
import c from '../../../classnames.scss'
import {PlansProps} from '.'

export const Plans = ({plans, translatedDetails}: PlansProps) => {
  const {t} = useTranslation()

  return (
    <>
      {plans.map(
        plan =>
          planVisible(plan) && (
            <div
              className={classNames(s.membershipItem, c.membershipOffersBorderColor)}
              data-hook={`${DH.MEMBERSHIP_OFFERS_PLAN}-${plan.id}`}
              key={plan.id}
            >
              <div className={s.content}>
                <div className={s.primary} data-hook={DH.MEMBERSHIP_OFFERS_PLAN_NAME}>
                  {plan.name}
                </div>
                <div className={s.secondary} data-hook={DH.MEMBERSHIP_OFFERS_PLAN_BENEFIT}>
                  {getPlanBenefitText(plan, t)}
                </div>
              </div>
              <div className={s.pricing}>
                <div
                  className={classNames(s.primary, {[s.withIcon]: plan.purchased})}
                  data-hook={DH.MEMBERSHIP_OFFERS_PLAN_PRICING}
                >
                  {plan.purchased ? (
                    <>
                      <Check className={s.purchasedIcon} />
                      {t('membership_purchased')}
                    </>
                  ) : (
                    [translatedDetails[plan.id]?.price, translatedDetails[plan.id]?.cycle].filter(Boolean).join(' / ')
                  )}
                </div>
                <div className={s.secondary} data-hook={DH.MEMBERSHIP_OFFERS_PLAN_INFO}>
                  {[translatedDetails[plan.id]?.duration, translatedDetails[plan.id]?.freeTrial]
                    .filter(Boolean)
                    .join(' ')}
                </div>
              </div>
            </div>
          ),
      )}
    </>
  )
}
